import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { themeGet } from 'styled-system';

import useBreakpoints, { isScreen } from '@shared/v2/hooks/useBreakpoints';

import { SCREEN_SIZE } from '../../../constants';
import { ANIMATIONS } from '../animations';

type BackdropProps = {
  children?: ReactNode;
  onClick?: () => void;
};

const StyledBackdrop = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(50, 50, 50, 0.8);
  z-index: ${themeGet('zIndices.popup')};
`;

const StyledWrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: stretch;
  justify-content: center;
  z-index: ${themeGet('zIndices.popup')};

  ${SCREEN_SIZE.LG} {
    align-items: center;
    padding: 3rem;
  }
`;

const Backdrop = ({ children, onClick }: BackdropProps) => {
  const breakpoints = useBreakpoints();
  const animation = ANIMATIONS.fadeInOnMobile;
  const smallScreen = isScreen(breakpoints)('xs', 'sm');
  const variant = smallScreen ? animation[0] : animation[2];
  if (!breakpoints) {
    return <></>;
  }
  return (
    <>
      <StyledBackdrop
        variants={variant}
        initial="hidden"
        animate="visible"
        exit="exit"
      />
      <StyledWrapper onClick={() => onClick?.()}>{children}</StyledWrapper>
    </>
  );
};

export default Backdrop;
